import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-layers-01',
  standalone: true,
  templateUrl: '../../assets/layers-01.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamLayers01Icon {}
